import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-charge',
  templateUrl: './modal-view-charge.component.html',
  styleUrls: ['./modal-view-charge.component.scss']
})
export class ModalViewChargeComponent implements OnInit {

  comertialAgreements: any = [];
  debtStatuses: any = this.uService.debtStatuses;
  dataSource: any = [];
  dataSource2: any = [];
  displayedColumns: any = [
    {variable: 'prod_code', displayedName: 'Código'},
    {variable: 'prod_name', displayedName: 'Nombre'},
    {variable: 'charge_type_translated', displayedName: 'Tipo de cobro'},
    {variable: 'quantity', displayedName: 'Volumen de transaccion'},
    {variable: 'amount', displayedName: 'valor a cobrar'},
  ];
  displayedColumns2: any = [
    {variable: 'id', displayedName: 'ID'},
    {variable: 'payment_date', displayedName: 'Fecha'},
    {variable: 'time', displayedName: 'Hora'},
    {variable: 'amount', displayedName: 'Monto'},
    {variable: 'gloss', displayedName: 'Glosa'},
  ];

  debtForm: FormGroup = new FormGroup({
    organization_id: new FormControl(''),
    name_organization: new FormControl(''),
    date: new FormControl(''),
    amount: new FormControl(''),
    status: new FormControl(''),
    balance: new FormControl(''),
  });

  newPaymentFromId(){
    var paymentId = this.debtForm.get('organization_id').value;
    var debtId = this.data['id'];

    this.dismiss();
    this.uService.newPayment.organization_id = paymentId;
    this.router.navigate([`/dashboard/new-payment/step-2/${paymentId}`]);
    this.uService.eventSetDebt$.next(debtId);
  }

  getComertialAgreements(){
    this.mService.get_request('commercial-agreements/list')
    .subscribe((resp: any)=>{
      if(resp.status){
        this.comertialAgreements = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  transformDate(dateToConvert: string){
    if(dateToConvert == null){
      var date = new Date(dateToConvert);
      var year = date.getFullYear().toString();
      var month = (date.getMonth() + 1).toString();
      var day = date.getDate().toString();

      if(Number(year) < 10){
        year = '0' + year;
      }
      if(Number(month) < 10){
        month = '0' + month;
      }
      if(Number(day) < 10){
        day = '0' + day;
      }
      return `${year}-${month}-${day}`
    }else{
      return '';
    }
  }

  getDebt(){
    this.mService.get_request('due-payment/list/detail', {id: this.data['id']})
    .subscribe((resp: any)=>{
      if(resp['status']){
        console.log(resp);
        this.debtForm.get('organization_id').setValue(resp['item']['organization_id']);
        this.debtForm.get('name_organization').setValue(resp['item']['name_organization']);
        this.debtForm.get('date').setValue(resp['item']['date']);
        this.debtForm.get('amount').setValue(resp['item']['amount']);
        this.debtForm.get('status').setValue(resp['item']['status']);
        this.debtForm.get('balance').setValue(resp['item']['balance']);

        this.dataSource = resp['item']['items'];
        this.dataSource2 = resp['item']['payments'];
      }
    })
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewChargeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.getDebt();
    this.getComertialAgreements();
    // this.debtForm.get('commercial_agreement_id').setValue(this.data.commercial_agreement_id);
    // this.debtForm.get('organization_id').setValue(this.data.organization_id);
    // this.debtForm.get('created_at').setValue( this.data.created_at);
    // this.debtForm.get('date').setValue(this.data.date);
    // this.debtForm.get('status').setValue(this.data.status);

    // this.dataSource = this.data.items;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

